import { faqSections } from "./faqData";

export const menuItems = [
  { name: "Dienstleistungen", key: "leistungen" },
  { name: "Case Studies", key: "fallstudien" },
  { name: "Karriere", key: "karriere" },
  { name: "FAQ", key: "faq", link: "/faq" },
  // { name: "Lösungen", key: "softwareloesungen" },
  // { name: "Technologien", key: "technologien" },
  // { name: "Über Uns", key: "about" },
  { name: "Kontakt", key: "contact" },
];

export const submenuData = {
  leistungen: [
    {
      title: "Software & Integration",
      items: [
        { name: "Softwareentwicklung", link: "/softwareentwicklung" },
        { name: "Systemanbindungen (ERP, CRM, DATEV)", link: "/systemanbindungen" },
        { name: "Systemerweiterung", link: "/systemerweiterung" },
        { name: "Buchungssysteme", link: "/buchungssysteme" },
      ],
    },
    {
      title: "Automatisierung",
      items: [
        { name: "Prozessautomatisierung", link: "/prozessautomatisierung" },
        { name: "Einführung von KI-Tools", link: "/ki-tools" },
      ],
    },
    {
      title: "Web",
      items: [
        { name: "Webseiten & Landingpages", link: "/webseiten-landingpages" },
        { name: "Online-Shops", link: "/online-shops" },
      ],
    },
    {
      title: "Reporting",
      items: [
        { name: "Dashboards & Visualisierung", link: "/dashboards-visualisierung" },
        { name: "Datenanalyse", link: "/datenanalyse" },
        { name: "KPI-Tracking", link: "/kpi-tracking" },
      ],
    },
    {
      title: "Support",
      items: [
        { name: "Cloud Migration", link: "/cloud-migration" },
        { name: "System Architektur", link: "/system-architektur" },
        { name: "IT-Security & DSGVO", link: "/it-security-dsgvo" },
      ],
    },
  ],
  fallstudien: [
    {
      title: "Software & Integration",
      items: [
        { name: "Probly", link: "/case-studies/probly" },
        { name: "Nodebase", link: "/case-studies/nodebase" },
        { name: "Mini-ERP", link: "/case-studies/mini-erp" },
      ],
    },
    {
      title: "Automatisierung",
      items: [],
    },
    {
      title: "Web",
      items: [],
    },
    {
      title: "Reporting",
      items: [],
    },
    {
      title: "Support",
      items: [],
    },
  ],
  faq: faqSections.map((section) => ({
    title: section.title,
    items: section.items.map((item) => ({
      name: item.question,
      link: `/faq#${item.id}`,
    })),
  })),
  // softwareloesungen: [
  //   {
  //     title: "Dokumentenmanagement",
  //     items: [
  //       {
  //         name: "Digitalisierung von Dokumenten",
  //         link: "/digitalisierung-von-dokumenten",
  //       },
  //       { name: "Elektronische Signaturen", link: "/elektronische-signaturen" },
  //     ],
  //   },
  //   {
  //     title: "Finanzautomatisierung",
  //     items: [
  //       {
  //         name: "Automatisierte Debitorenbuchung",
  //         link: "/automatisierte-debitorenbuchung",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Digitale Geschäftsprozesse",
  //     items: [
  //       { name: "Workflow-Automatisierung", link: "/workflow-automatisierung" },
  //       { name: "Middleware-Lösungen", link: "/middleware-loesungen" },
  //     ],
  //   },
  // ],
  // technologien: [
  //   // {
  //   //   title: "Industrie 4.0",
  //   //   items: [
  //   //     { name: "Predictive Maintenance", link: "/predictive-maintenance" },
  //   //     { name: "Digitale Zwillinge", link: "/digitale-zwillinge" },
  //   //   ],
  //   // },
  //   {
  //     title: "Data Analytics",
  //     items: [
  //       { name: "Künstliche Intelligenz", link: "/kuenstliche-intelligenz" },
  //     ],
  //   },
  // ],
  about: [
    {
      title: "Unternehmen",
      items: [
        { name: "Unsere Geschichte", link: "/unsere-geschichte" },
        { name: "Vision und Mission", link: "/vision-und-mission" },
      ],
    },
    {
      title: "Team",
      items: [{ name: "Mitarbeiter", link: "/mitarbeiter" }],
    },
  ],
  karriere: [
    {
      title: "Karriere",
      items: [{ name: "Initiativbewerbung", action: "contact" }],
    },
  ],
  contact: [
    {
      title: "Kontaktmöglichkeiten",
      items: [{ name: "Kontaktformular", action: "contact" }],
    },
    // {
    //   title: "Support",
    //   items: [{ name: "FAQ", link: "/faq" }],
    // },
  ],
};
